import moment from 'moment';
import { useEffect, useState } from 'react';
import { transactionPoker } from '../../../../constants/transaction_history';
import { isSmartPhone } from '../../../../utilities/helper';
import PokerHistoryWeb from './index_web';
import PokerHistoryMWeb from './index_mWeb';

const PokerHistory = () => {
  const [pokerTransactionList, setPokerTransactionList] = useState([] as any);
  const [error, setError] = useState(false);
  const [resultArrived, setResultArrived] = useState(false);
  const [skip, setSkip] = useState(0);
  const [hasMoreItems, setHasMoreItems] = useState(true);
  useEffect(() => {
    getData();
  }, []);

  const getData = (skip = 0) => {
    const result = transactionPoker;
    setResultArrived(true);
    if (!error && result) {
      let transactionList: any = [];
      const { result: data = [] } = result;
      setHasMoreItems(false);
      setSkip(skip + data.length);
      data.forEach((item: any) => {
        let {
          primaryWalletPayment = [],
          bonusWalletPayment = [],
          gameWalletPayment = [],
          pokerWalletPayment = [],
          game = '',
          entryFee = 0,
          gameId = '',
          matchTitle = null
        } = item;
        primaryWalletPayment.map((item: any) => {
          item.entryFee = entryFee;
          item.game = game;
          item.gameId = gameId;
          item.walletType = 'iGamio / Poker';
          item.matchTitle = matchTitle;
          return item;
        });
        bonusWalletPayment.map((item: any) => {
          item.entryFee = entryFee;
          item.game = game;
          item.gameId = gameId;
          item.walletType = 'Bonus';
          item.matchTitle = matchTitle;
          return item;
        });
        gameWalletPayment.map((item: any) => {
          item.entryFee = entryFee;
          item.game = game;
          item.gameId = gameId;
          item.walletType = 'Play';
          item.matchTitle = matchTitle;
          return item;
        });
        pokerWalletPayment.map((item: any) => {
          item.entryFee = entryFee;
          item.game = game;
          item.gameId = gameId;
          item.walletType = 'Poker';
          item.matchTitle = matchTitle;
          return item;
        });
        transactionList = transactionList.concat(primaryWalletPayment);
        transactionList = transactionList.concat(bonusWalletPayment);
        transactionList = transactionList.concat(gameWalletPayment);
        transactionList = transactionList.concat(pokerWalletPayment);
      });

      transactionList.sort(function (
        a: { createdOn: moment.MomentInput },
        b: { createdOn: moment.MomentInput }
      ) {
        return (
          moment(b.createdOn, 'YYYY-MM-DD HH:mm:ss').valueOf() -
          moment(a.createdOn, 'YYYY-MM-DD HH:mm:ss').valueOf()
        );
      });

      if (skip === 0) {
        setPokerTransactionList(transactionList);
      } else {
        setPokerTransactionList((data1: any) => [...data1, ...transactionList]);
      }
    } else {
      setError(true);
    }
  };
  const _onRefresh = async () => {
    setSkip(0);
    setHasMoreItems(true);
    getData();
  };

  const loadMoreItems = () => {
    if (!hasMoreItems) return;
    getData(skip);
  };

  const onPressRetryGame = () => {
    setResultArrived(false);
    getData();
  };
  return (
    <>
      {!isSmartPhone ? (
        <PokerHistoryWeb
          error={error}
          resultArrived={resultArrived}
          _onRefresh={_onRefresh}
          hasMoreItems={hasMoreItems}
          loadMoreItems={loadMoreItems}
          onPressRetryGame={onPressRetryGame}
          pokerTransactionList={pokerTransactionList}
        />
      ) : (
        <PokerHistoryMWeb
          error={error}
          resultArrived={resultArrived}
          _onRefresh={_onRefresh}
          hasMoreItems={hasMoreItems}
          loadMoreItems={loadMoreItems}
          onPressRetryGame={onPressRetryGame}
          pokerTransactionList={pokerTransactionList}
        />
      )}
    </>
  );
};

export default PokerHistory;
